export const BaseApiUrl = process.env.REACT_APP_BASE_URL

